import { styled, Box } from '../../../../base';

export const StyledFileUploadContainer = styled(Box)(() => ({
    width: '100%',
    height: '100%', // Attempt to make it take full height of its parent in CompanyQuestion
    minHeight: '200px', // Ensure a reasonable minimum height for the dropzone area
    display: 'flex',
    flexDirection: 'column',

    // Target the FormUploadFile's internal structure if direct props like sx don't suffice.
    // This assumes FormUploadFile or its child UploadFile renders a root Box or similar
    // that can be targeted or inherits these flex properties.
    '& > div': {
        // Assuming FormUploadFile renders a div as its root or main container
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
    },
    // Specifically target the StyledDropZone within FormUploadFile if possible.
    // This might require knowledge of FormUploadFile's exact DOM structure or class names.
    // For a generic approach, we hope FormUploadFile's own sx prop or internal styling allows expansion.
    // The UploadFile component (used by FormUploadFile) has a root Box with sx prop and a StyledDropZone.
    // We might need to pass sx to FormUploadFile to style its child UploadFile's root Box and StyledDropZone.
    // Example: sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', '& .MuiBox-root': { height: '100%' etc. } }}
    // For now, let's rely on FileUploadAction passing sx to FormUploadFile to make it full height.
}));
